import React, { memo } from "react";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";

import PayWaiterContent from "./PayWaiterContent";
import { IPayWaiterConfirmationProps } from "./types";

const PayWaiterConfirmation = memo(
    ({ show, onPrimaryClick, isError, onCardClose }: IPayWaiterConfirmationProps) => {
        return (
            <HalfCard
                isOpen={show}
                closeOnOverlayClick={true}
                hideCloseIcon={!isError}
                hasCustomPadding={true}
                onClose={onCardClose}
            >
                <PayWaiterContent onPrimaryClick={onPrimaryClick} isError={isError} />
            </HalfCard>
        );
    }
);

PayWaiterConfirmation.displayName = "PayWaiterConfirmation";

export default PayWaiterConfirmation;
